<template>
  <div>
    <div v-html="privacyContent"></div>
  </div>
</template>

<script>
import axios from 'axios';
const wutongBaseUrl = 'https://dev.wutong.co.nz/api'

const http = axios.create({
  baseURL: wutongBaseUrl,
  timeout: 5000, // 可选：超时设置
  headers: {
    'Content-Type': 'application/json'
  }
})
const tuitionContent = '/app-client/tuition/page/content'

export default {
  name: 'AppPrivicy',
  data() {
    return {
      privacyContent: ''
    }
  },
  methods: {
  },
  mounted() {
    http.get(tuitionContent, {
      params: {
        page: 'privacy'
      }
    }).then(res => {
      if (res.data.error_code === 0) {
        this.privacyContent = res.data.data.privacy_policy.cn_content;
      } else {
        this.$message.error('获取隐私政策失败');
      }
    }).catch(error => {
      console.error('Error fetching privacy content:', error);
      this.$message.error('获取隐私政策失败');
    });
  }
}
</script>

<style scoped>

</style>
